import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'

import IndexView from "./Index/View"

import CreatePeriodeView from "./CreatePeriode/View"
import IndexCPNSView from "./IndexCPNS/View"
import UploadSKView from "./UploadSK/View"
import DetailCPNSView from "./DetailCPNS/View"
import DetailPNSView from "./DetailPNS/View"


const RouteView = (props) => {

  const queryParams = new URLSearchParams(props.location.search);
  const _create = queryParams.get('create')
  const _index_cpns = queryParams.get('index_cpns')
  const _detail = queryParams.get('detail')
  const _detail_pns = queryParams.get('detail_pns')
  const _delete = queryParams.get('delete')
  const _approve = queryParams.get('approve')
  const _print = queryParams.get('print')
  const _update = queryParams.get('update')
  const _upload_sk = queryParams.get('upload_sk')

  const _uuid = queryParams.get('uuid')

  if (_create != null) {
    return accessRole('create') ? <CreatePeriodeView /> : <ErrorAccess />
  } else if (_detail != null) {
    return accessRole('read') ? <DetailCPNSView /> : <ErrorAccess />
  } else if (_detail_pns != null) {
    return accessRole('read') ? <DetailPNSView /> : <ErrorAccess />
  }else if (_update != null) {
    return accessRole('update') ? null : <ErrorAccess />
  } else if (_delete != null) {
    return null
  } else if (_approve != null) {
    return accessRole('approve') ? null: <ErrorAccess />
  } else if (_index_cpns != null) {
    return accessRole('create') ? <IndexCPNSView/> : <ErrorAccess />
  } else if (_upload_sk != null) {
    return accessRole('approve') ? <UploadSKView/> : <ErrorAccess />
  } else if (_print != null) {
    return null
  }
  return accessRole('read') ? <IndexView /> : <ErrorAccess />

}
export default RouteView
